import { combineReducers } from 'redux';
import { User,  Vessel } from '../../types';
import { SET_USER, SET_VESSEL } from '../constants/action-types';
import { AppState } from '../constants/types';

const initialState: AppState = {
  user: {} as User,
  vessel: {} as Vessel
};

function appStateReducer(
  state: AppState = initialState,
  action: { type: string; payload: any }
) {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.payload };
    case SET_VESSEL:
      return { ...state, vessel: action.payload };
    default:
      return state;
  }
}

const allReducers = {
  appState: appStateReducer
};

const rootReducer = combineReducers(allReducers);

export default rootReducer;
